import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted, ref } from 'vue';
import { Resources } from './Resources';


export default /*#__PURE__*/_defineComponent({
  __name: 'Resource',
  props: {
    res: { type: String, required: true },
    replaceWith: { type: String, required: false },
    placeholder: { type: String, required: false },
    args: { type: Array, required: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    /** The resource key */
    res: string,
    /** Use this string verbatim if defined */
    replaceWith?: string
    /** Show this while the actual string is loading */
    placeholder?: string
    /** Strings to be inserted into the resource */
    args?: string[]
}



let str = ref(props.placeholder ?? "");

onMounted(() => {
    Resources.GetInstance()
        .then((res) => {
            let value = res.GetResource(props.res);
            if (props.args != undefined) {
                for (let i = 0; i < props.args.length; i++) {
                    value = value.replace(`{${i}}`, props.args[i]);
                }
            }
            str.value = value;
        });
})

const __returned__ = { props, str }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})